
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 8C6 6.89543 6.89543 6 8 6H24C25.1046 6 26 6.89543 26 8V19.7574C26 20.2878 25.7893 20.7965 25.4142 21.1716L23.2929 23.2929L21.1716 25.4142C20.7965 25.7893 20.2878 26 19.7574 26H8C6.89543 26 6 25.1046 6 24V8Z","stroke":"#10001F","stroke-width":"2"}}),_c('path',{attrs:{"d":"M21 13H10.9412C10.6916 13 10.4522 12.8946 10.2757 12.7071C10.0992 12.5196 10 12.2652 10 12C10 11.7348 10.0992 11.4804 10.2757 11.2929C10.4522 11.1054 10.6916 11 10.9412 11H21C21.2496 11 21.489 11.1054 21.6655 11.2929C21.842 11.4804 21.9412 11.7348 21.9412 12C21.9412 12.2652 21.842 12.5196 21.6655 12.7071C21.489 12.8946 21.2496 13 21 13Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M21 17H10.9412C10.6916 17 10.4522 16.8946 10.2757 16.7071C10.0992 16.5196 10 16.2652 10 16C10 15.7348 10.0992 15.4804 10.2757 15.2929C10.4522 15.1054 10.6916 15 10.9412 15H21C21.2496 15 21.489 15.1054 21.6655 15.2929C21.842 15.4804 21.9412 15.7348 21.9412 16C21.9412 16.2652 21.842 16.5196 21.6655 16.7071C21.489 16.8946 21.2496 17 21 17Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M18 21H10.9412C10.6916 21 10.4522 20.8946 10.2757 20.7071C10.0992 20.5196 10 20.2652 10 20C10 19.7348 10.0992 19.4804 10.2757 19.2929C10.4522 19.1054 10.6916 19 10.9412 19H18C18.2496 19 18.489 19.1054 18.6655 19.2929C18.842 19.4804 18.9412 19.7348 18.9412 20C18.9412 20.2652 18.842 20.5196 18.6655 20.7071C18.489 20.8946 18.2496 21 18 21Z","fill":"#10001F"}})])
          )
        }
      }
    